<template>
  <div
    class="bg-box"
  >
    <top-title
      name="实物管理"
      style="margin: 20px; min-width: 980px"
    ></top-title>
    <div class="integralEden">
      <div class="content">
        <!-- 头部导航切换 -->
        <div class="navTab">
          <span
            class="tab"
            :class="{ active: tabActive == 1 }"
            @click="handleClick(1)"
            >实物管理</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 2 }"
            @click="handleClick(2)"
            >发放记录</span
          >
        </div>
        <physical
          v-if="tabActive == 1"
          @checkGrantRecord="checkGrantRecord"
        ></physical>
        <physicalList v-if="tabActive == 2" :goodsId="goodsId"></physicalList>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
import physical from "./_components/physical.vue";
import physicalList from "./_components/physicalList.vue";
export default {
  components: {
    topTitle,
    physical,
    physicalList,
  },
  data() {
    return {
      tabActive: 1,
      goodsId: "",
    };
  },
  mounted() {
    if(this.$route.query.id) {
      this.id = this.$route.query.id
      this.tabActive = this.$route.query.tabActive
    }
  },
  computed: {},
  methods: {
    handleClick(index) {
      this.tabActive = index;
      this.goodsId = "";
    },
    checkGrantRecord(val) {
      this.tabActive = val.activeIndex;
      this.goodsId = val.goodsId;
    },
  },
};
</script>

<style scoped lang="scss">
.bg-box {
  display: flex;
  flex-direction: column;
  .integralEden {
    margin: 0 20px 20px;
    min-width: 1080px;
    height: 100%;
    flex: 1;
    .content {
      padding: 20px 0;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      flex: 1;
      .navTab {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 20px;
        position: relative;
        height: 50px;
        font-size: 14px;
        color: #666;
        border-bottom: 1px solid #f6f6f6;
        .tab {
          // width: 100px;
          padding: 0 20px;
          height: 50px;
          line-height: 50px;
          position: relative;
          // padding: 0 11px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .active {
          color: #7b61ff;
          &::before {
            content: "";
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 80%;
            height: 2px;
            background-color: #7b61ff;
            transition: all 0.2s;
            animation: opation 0.2s;
          }
        }
      }
      .dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        opacity: 1;
        margin-right: 7px;
      }
      .dot-0 {
        background: #cccccc;
      }
      .dot-1 {
        background: #cccccc;
      }
      .dot-2 {
        background: #7f85e9;
      }
      .dot-3 {
        background: #7b61ff;
      }
      .pagination {
        margin: 40px 80px 0 0;
        text-align: right;
      }
      .buttonBox {
        .b1 {
          width: 98px;
          height: 32px;
          color: #666666;
          // position: absolute;
          border-radius: 3px;
          margin-top: 20px;
          border: 1px solid #dddddd;
          background-color: #fff;
          &:hover {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
          &:active {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
        }
        .b2 {
          width: 98px;
          // position: absolute;
          // margin-right: 80px;
          height: 32px;
          margin: 20px 80px 10px 10px;
          border: 1px solid #7b61ff;
          color: #ffffff;
          border-radius: 3px;
          background-color: #7b61ff;
          &:hover {
            color: #fff;
            opacity: 0.9;
            background-color: #7b61ff;
          }
          &:active {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
        }
      }
    }
  }
}
</style>
